import React, { ReactNode } from "react";
import { IModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { AvatarName } from "../AvatarName";
import { Box } from "@mui/material";

interface IModifyUserInfoProp {
    classes?: string;
    modifyUser: IModifyUser;
    suffixElement?: ReactNode;
}

export const ModifyUserInfo = (props: IModifyUserInfoProp) => {
    if ((!props.modifyUser || !props.modifyUser.date) && !props.suffixElement) return null;
        
    if (props.modifyUser && props.modifyUser.date) {
        const modifyUser = props.modifyUser;
        return (
            <AvatarName
                classes={props.classes}
                code={modifyUser.code}
                date={modifyUser.date}
                name={modifyUser.name}
                picture={modifyUser.picture}
                suffixElement={props.suffixElement}
            />
        );
    }

    return (
        <Box display="flex" alignItems="center" sx={{ cursor: "default", overflow: "hidden" }}>
            {!!props.suffixElement &&
                <Box sx={{ marginLeft: "auto" }}>
                    {props.suffixElement}
                </Box>
            }
        </Box>
    );
};